import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, AbstractControlOptions, AbstractControl } from '@angular/forms';

export abstract class IFormMapper {
    public abstract appendToGroup<TItem>(form: UntypedFormGroup, item: TItem): void;

    public abstract createGroup<TItem>(item: TItem, options?: AbstractControlOptions): UntypedFormGroup;

    public abstract createArray<TItem>(items: TItem[]): UntypedFormArray;

    public abstract createControl<TItem>(item: TItem): UntypedFormControl;

    public abstract setFormControlFromModel(form: AbstractControl, obj: any, parentKey?: string): void;
}
